import { History, SupervisedUserCircle } from "@mui/icons-material";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import { IconButton } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { formatDistance } from "date-fns";
import { useContext, useState, useEffect } from "react";

import { inject } from "../../../../../../lib/itn-ui-kit/services/service-container";
import DataContext from "../../../../../context/DataContext";
import PermissionWrapper from "../../../../global/PermissionWrapper";
import ResponseModal from "../../../../global/ResponseModal";
import { useToastOnCopy } from "../../../../modules/ai-summary/hooks/useToastOnCopy";
import UploadDocuments from "../../../../modules/Documents/UploadDocuments";
import ClientSearchMinimized from "../ClientSearchMinimized";
import LiensBalancesModal from "../Settlement/LiensBalancesModal";

import CaseAssignment from "./CaseAssignment";
import ContactTypeBadges from "./ContactTypeBadges";
import ClientDetailProvider from "./context/ClientDetailContext";
import LawFirmDetails from "./LawFirmDetails";
import StaticBar from "./StaticBar";
import StaticBarProvider from "./StaticBar/context/StaticBarContext";
import TabClientNotesCallLog from "./TabClientNotesCallLog";

export default function ClientDetail({ _case, contactTypeBadges = [], children }) {
  /* TODO REMOVE THIS FILE once all perms are using currentUser service*/
  const { userRoles, userType } = useContext(DataContext);
  const currentUserService = inject("current-user-service");

  const [openError, setOpenError] = useState(false);
  const [errorArray, setErrorArray] = useState([]);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [caseObj, setCaseObj] = useState();
  const [uploadDocument, setUploadDocument] = useState(false);
  const [viewDocuments, setViewDocuments] = useState(false);
  const [openLfDetails, setOpenLfDetails] = useState(false);
  const [docNeedsType, setDocNeedsType] = useState();
  const [openExpense, setOpenExpense] = useState(false);
  // const { isUploadModalOpen } = useDocumentListStore(); // TODO: check if needed
  useToastOnCopy();

  const hasPermission = (key, obj) => {
    if (!currentUserService?.user?.permissions_map) {
      return false;
    }
    return key in obj;
  };
  const canViewFollowUps =
    hasPermission("casemanager.can_view_follow_ups", currentUserService?.user?.permissions_map) +
      hasPermission(
        "casemanager.can_view_actionableitems",
        currentUserService?.user?.permissions_map
      ) ===
    1
      ? true
      : false;
  const canViewNotes = hasPermission(
    "casemanager.view_casenotes",
    currentUserService?.user?.permissions_map
  );
  const canViewCallLog = hasPermission(
    "call_log.view_calllog",
    currentUserService?.user?.permissions_map
  );

  useEffect(() => {
    setCaseObj(_case);
  }, [_case]);

  /*TODO MAKE SURE THIS IS MOVED TO DOCUMENT LIST-If functionality exists. Ask Michael if new story is needed.  useEffect(() => {
    if (
      !id ||
      !userRoles.permissions.includes("filemanager.view_document") ||
      !caseObj
    ) {
      return;
    } else {
      axios
        .get(`/api/case/${caseObj.pk}/missing-docs/`, {
        })
        .then((response) => {
          let data = response.data;
          setDocNeedsType(data);
        });
    }
  }, [accessToken, userRoles.permissions, caseObj, setDocNeedsType, id]); */

  if (caseObj?.id) {
    return (
      <>
        <div className="flex max-h-min flex-row" style={{ gap: "20px" }}>
          <div className="flex flex-1 flex-col" style={{ borderRadius: "12px" }}>
            <StaticBarProvider>
              <ClientDetailProvider>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <p className="text-normal mr-2 text-right text-[12px] text-gray-700">
                    {!caseObj || userType !== "Client Case Management" ? (
                      ""
                    ) : (
                      <>
                        <Tooltip title={"Case Last Updated"}>
                          <History />
                        </Tooltip>
                        &nbsp;
                        <span>
                          {new Date(caseObj.updatedAt).toLocaleString("en-US", {
                            dateStyle: "short",
                            timeStyle: "short",
                          })}
                          &nbsp;(
                          {formatDistance(new Date(caseObj.updatedAt), new Date())})
                        </span>
                      </>
                    )}
                  </p>
                  <div
                    className="flex w-full flex-1 flex-col bg-red-600 lg:flex-row"
                    style={{
                      borderRadius: "12px",
                      backgroundColor: "transparent",
                    }}
                  >
                    <div
                      className={`${
                        userRoles.permissions.includes("casemanager.view_casenotes")
                          ? "flex-1"
                          : "w-full"
                      } flex flex-col`}
                      style={{ flex: 1 }}
                    >
                      <div
                        style={{
                          borderRadius: "15px",
                          backgroundColor: "#fff",
                          padding: "15px 35px",
                          boxShadow: "3px 3px 10px 0px #BCD1FF",
                        }}
                      >
                        <div className="relative flex flex-col items-center xl:flex-row">
                          <div className="w-full xl:w-1/3">
                            <ClientSearchMinimized />
                          </div>
                          <div className="w-full xl:w-2/3">
                            <div>
                              {" "}
                              {/* shrink-0 keeps the entity and law firm off the badges'
                                  hands so neither gets squeezed into wrapping; max-w-full
                                  still lets an unusually long name wrap inside the row
                                  rather than overflowing it. */}
                              <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1">
                                <div className="max-w-full shrink-0">
                                  {caseObj?.entity?.name ? (
                                    <div className="flex items-center justify-center text-center text-[14px] font-bold">
                                      <Tooltip title="Entity">
                                        <SupervisedUserCircle className="text-[18px]" />
                                      </Tooltip>
                                      <p>{caseObj?.entity?.name} -</p>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                                <div className="max-w-full shrink-0">
                                  <IconButton
                                    className="mr-2 w-[20px]"
                                    onClick={() => setOpenLfDetails(true)}
                                    disabled={
                                      userRoles.permissions.includes("lawyer.view_all_law_firms") &&
                                      caseObj?.lawFirm
                                        ? false
                                        : true
                                    }
                                  >
                                    <Tooltip title="Open Law Firm Details">
                                      <AccountBalanceIcon className="text-black" />
                                    </Tooltip>
                                  </IconButton>
                                  {caseObj?.lawFirmName ?? "No Law Firm Assigned"}
                                </div>
                                <ContactTypeBadges badges={contactTypeBadges} />
                              </div>
                            </div>
                            {userRoles.permissions.includes("users.view_usertocaseassignments") && (
                              <CaseAssignment caseObj={caseObj} />
                            )}
                          </div>
                        </div>
                        <StaticBar
                          setViewDocuments={setViewDocuments}
                          setUploadDocument={setUploadDocument}
                          docNeedsType={docNeedsType}
                          setOpenExpense={setOpenExpense}
                        />
                      </div>
                      <LiensBalancesModal
                        openExpense={openExpense}
                        setOpenExpense={setOpenExpense}
                      />
                      <div className="pt-4">{children}</div>
                    </div>
                    <ResponseModal
                      title="Case Info"
                      description="Case Information Updated"
                      openBool={openSuccess}
                      setOpenBool={setOpenSuccess}
                    />
                    <LawFirmDetails
                      lawFirmId={caseObj?.lawFirm}
                      openLfDetails={openLfDetails}
                      setOpenLfDetails={setOpenLfDetails}
                    />
                  </div>
                  <ResponseModal
                    title="Success"
                    description="The case content was updated"
                    openBool={openSuccess}
                    setOpenBool={setOpenSuccess}
                  />
                  <ResponseModal
                    title="Case update failed"
                    isError={true}
                    openBool={openError}
                    setOpenBool={setOpenError}
                    errorMessage={errorArray}
                  />
                </LocalizationProvider>
              </ClientDetailProvider>
            </StaticBarProvider>
          </div>
          <PermissionWrapper permission={canViewFollowUps || canViewNotes || canViewCallLog}>
            <div
              className="flex flex-col"
              style={{
                width: "30%",
                display: "flex",
                flexDirection: "column",
                backgroundColor: "#fff",
                borderRadius: "15px",
                boxShadow: "3px 3px 10px 0px #BCD1FF",
              }}
            >
              <div className="flex h-full w-full flex-1 flex-col">
                <TabClientNotesCallLog
                  canViewCallLog={canViewCallLog}
                  canViewFollowUps={canViewFollowUps}
                  canViewNotes={canViewNotes}
                  caseObj={caseObj}
                />
              </div>
            </div>
          </PermissionWrapper>
        </div>
        <UploadDocuments isModal={true} />
      </>
    );
  } else {
    return (
      <div className="mt-20 h-1/2 w-full rounded-lg text-center text-2xl hover:bg-gray-200">
        <br />
        Please Select a Client to View Client's Details...
      </div>
    );
  }
}
